var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from '@mui/material/styles';
import TextField from '../TextField';
import InputAdornment from '../InputAdornment';
import SearchIcon from '../Icons/Core/Search';
import IconButton from '../IconButton';
import ClearIcon from '../Icons/Core/Clear';
import Autocomplete from '../Autocomplete';
export function SearchField(_a) {
    var { disabled = false, id, label, onChange, onClick, options, placeholder, value } = _a, rest = __rest(_a, ["disabled", "id", "label", "onChange", "onClick", "options", "placeholder", "value"]);
    const theme = useTheme();
    const handleClear = () => {
        if (onChange) {
            const event = {
                target: { value: '' },
                currentTarget: { value: '' }
            };
            onChange(event);
        }
    };
    return (options === null || options === void 0 ? void 0 : options.length) ? (React.createElement(Autocomplete, { "data-testid": id || 'autocomplete-search', disableClearable: true, freeSolo: true, fullWidth: true, id: id || 'autocomplete-search', options: options, value: value, renderInput: params => (React.createElement(TextField, Object.assign({}, params, { label: label, placeholder: placeholder, onChange: onChange, InputProps: Object.assign({}, params.InputProps) }))) })) : (React.createElement(TextField, Object.assign({ id: id || 'search', "data-testid": id || 'search', disabled: disabled, label: label, fullWidth: true, placeholder: placeholder, value: value, onChange: onChange, InputProps: {
            endAdornment: (React.createElement(React.Fragment, null,
                value && (React.createElement(InputAdornment, { position: "end", sx: { ml: 0 } },
                    React.createElement(IconButton, { "aria-label": "clear", bdsSize: "medium", onClick: handleClear },
                        React.createElement(ClearIcon, { fontSize: "inherit" })))),
                React.createElement(InputAdornment, { position: "end", sx: { ml: theme.palette.textField.spaceBetween } },
                    React.createElement(IconButton, { "aria-label": "search", onClick: onClick, bdsSize: "medium" },
                        React.createElement(SearchIcon, { fontSize: "inherit" })))))
        } }, rest)));
}
export default SearchField;
//# sourceMappingURL=SearchField.js.map